import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.QIS_SERVER_PREFIX}/fertilizer-allocation`;
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    create: () => `${RESOURCE_ENDPOINT}`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
    getDistrictwiseAllocationSampleData: () => `${RESOURCE_ENDPOINT}/getDistrictwiseAllocationSampleData`,
    getAllocationSampleData: () => `${RESOURCE_ENDPOINT}/getAllocationSampleData`,
    getTotalAllocationData: () => `${RESOURCE_ENDPOINT}/getTotalAllocationData`,
    getFertilizerAllocation: () => `${RESOURCE_ENDPOINT}/get-fertilizer-allocation`,
    getAllocationByDistrictId: () => `${RESOURCE_ENDPOINT}/get-fertilizer-allocation-district`,
};

export default class FertilizerAllocation {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();

        return HttpService.get(url, params, headers);
    };

    public getById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url);
    };

    public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    };

    public update = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    };

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    };

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    };

    public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    };

    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdown();
        return HttpService.get(url, params, headers);
    };


    public getAllocationSampleData = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getAllocationSampleData();
        return HttpService.get(url, params, headers);
    };

    public getDistrictwiseAllocationSampleData = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getDistrictwiseAllocationSampleData();
        return HttpService.get(url, params, headers);
    };

    public getTotalAllocationData = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getTotalAllocationData();
        return HttpService.get(url, params, headers);
    };

    public getFertilizerAllocation = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getFertilizerAllocation();
        return HttpService.post(url, payload, params, headers);
    };

     public getAllocationByDistrictId = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getAllocationByDistrictId();
        return HttpService.post(url, payload, params, headers);
    };
}
